export const ja = {
  "app.title": "survivrr.io",
  "menu.online": "オンライン",
  "menu.offline": "オフライン",
  "menu.play": "プレイ",
  "menu.name": "名前",
  "menu.ballColor": "ボールの色",
  "menu.nameColor": "名前の色",
  "menu.moreInfo": "詳細情報",
  "menu.moreInfoTitle": "詳細情報",
  "menu.moreInfoSubtitle": "法的ページ、Cookie の詳細、連絡先情報。",
  "menu.back": "戻る",
  "menu.privacySettings": "プライバシー設定",
  "menu.cookiePolicy": "Cookie ポリシー",
  "menu.privacyPolicy": "プライバシーポリシー",
  "menu.termsOfService": "利用規約",
  "menu.emailButton": "メールする",
  "menu.websiteButton": "サイトを見る",
  "menu.contactEmailLabel": "連絡先メール:",
  "menu.emailLabel": "メール:",
  "menu.websiteLabel": "サイトを見る:",
  "menu.nameRequired": "先に名前を入力してください。",
  "moreInfo.privacySettings.intro1": "このサイトでは、利用可能な場合に広告プロバイダーが表示する同意メッセージからプライバシー設定を管理できます。",
  "moreInfo.privacySettings.intro2": "Cookie とローカルストレージは、いつでもブラウザ設定から管理できます。",
  "moreInfo.privacySettings.adsHeading": "広告設定",
  "moreInfo.privacySettings.adsParagraph": "一部の広告は Google または他のパートナーによって提供される場合があります。パーソナライズ広告の設定は Google の広告設定から直接管理することもできます。",
  "moreInfo.privacySettings.adsBullet1": "Google の広告設定を myadcenter.google.com で開きます。",
  "moreInfo.privacySettings.adsBullet2": "同意設定をリセットしたい場合は、Cookie またはサイトデータを削除してください。",
  "moreInfo.privacySettings.adsBullet3": "Cookie をブロックまたは制限するには、ブラウザのプライバシー設定を使用してください。",
  "moreInfo.privacySettings.localHeading": "ローカル設定",
  "moreInfo.privacySettings.localParagraph": "このゲームは、プレイヤー名、色、音声設定、言語などの基本的なローカル設定を保存し、このサイトが端末上でそれらを記憶できるようにします。",
  "moreInfo.cookiePolicy.intro1": "このサイトは、ゲームの実行、設定の記憶、広告のサポートのために Cookie と類似の保存技術を使用します。",
  "moreInfo.cookiePolicy.intro2": "Cookie は、同意設定やサイトで有効なサービスに応じて、測定、不正防止、広告のパーソナライズにも使用される場合があります。",
  "moreInfo.cookiePolicy.typesHeading": "使用する可能性のある Cookie と保存の種類",
  "moreInfo.cookiePolicy.typeBullet1": "サイトを動作させるために必要な必須ストレージ。",
  "moreInfo.cookiePolicy.typeBullet2": "名前、色、言語、音声設定を記憶するための設定ストレージ。",
  "moreInfo.cookiePolicy.typeBullet3": "広告が有効な場合に Google などの広告パートナーが使用する広告または測定 Cookie。",
  "moreInfo.cookiePolicy.manageHeading": "Cookie の管理方法",
  "moreInfo.cookiePolicy.manageParagraph": "Cookie は、利用可能な場合はサイトの同意メッセージから、またはブラウザ設定から管理できます。一部の Cookie を無効にすると、サイト機能や広告配信に影響する場合があります。",
  "moreInfo.privacyPolicy.intro1": "このサイトは Michał Kierzkowski が運営するブラウザゲームです。個人情報の収集はできるだけ少なくすることを目指しています。",
  "moreInfo.privacyPolicy.intro2": "プレイにアカウントは必要ありません。ゲームは端末に基本的なローカル設定を保存し、オンラインマッチに必要なゲームデータを処理する場合があります。",
  "moreInfo.privacyPolicy.infoHeading": "処理する可能性のある情報",
  "moreInfo.privacyPolicy.infoBullet1": "選択したプレイヤー名と外観設定。",
  "moreInfo.privacyPolicy.infoBullet2": "マルチプレイヤー機能に必要な基本的なセッションデータ。",
  "moreInfo.privacyPolicy.infoBullet3": "有効になっている場合、分析または広告パートナーが収集する端末、ブラウザ、広告データ。",
  "moreInfo.privacyPolicy.useHeading": "情報の使用方法",
  "moreInfo.privacyPolicy.useBullet1": "ゲームとオンラインルームを運営するため。",
  "moreInfo.privacyPolicy.useBullet2": "端末上で設定を記憶するため。",
  "moreInfo.privacyPolicy.useBullet3": "パフォーマンス、セキュリティ、安定性を向上するため。",
  "moreInfo.privacyPolicy.useBullet4": "広告が有効な場合に広告を表示するため。",
  "moreInfo.privacyPolicy.contactHeading": "連絡先",
  "moreInfo.privacyPolicy.contactParagraph1": "プライバシーに関する質問は、こちらまでご連絡ください: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "ウェブサイト: michalkierzkowski.com",
  "moreInfo.terms.intro1": "このサイトを使用することで、合法かつ公正な方法でゲームを使用することに同意したものとします。",
  "moreInfo.terms.intro2": "ゲームは現状のまま提供され、いつでも変更、中断、削除される場合があります。",
  "moreInfo.terms.rulesHeading": "ルール",
  "moreInfo.terms.ruleBullet1": "バグ、チート、自動化、エクスプロイトを悪用しないでください。",
  "moreInfo.terms.ruleBullet2": "サービスや他のプレイヤーに害を与えようとしないでください。",
  "moreInfo.terms.ruleBullet3": "攻撃的、違法、または誤解を招く名前やコンテンツを使用しないでください。",
  "moreInfo.terms.limitationHeading": "制限",
  "moreInfo.terms.limitationParagraph": "法律で認められる最大限の範囲で、サイトの使用によって生じる損失、中断、損害について責任を負いません。",
  "moreInfo.terms.changesHeading": "変更",
  "moreInfo.terms.changesParagraph": "これらの規約は将来更新される場合があります。更新後もサイトを使用し続けることは、更新された規約に同意したことを意味します。",
  "status.offline": "オフラインマッチを開始中...",
  "status.connecting": "サーバーに接続中...",
  "queue.title": "ルーム待機中",
  "queue.menu": "メインメニューに戻る",
  "game.pressToMove": "任意の場所を押して移動",
  "game.touchToMove": "任意の場所をタッチして移動",
  "game.leaderboard": "ランキング",
  "game.hp": "HP",
  "game.level": "レベル",
  "game.xp": "XP",
  "game.respawning": "リスポーン中...",
  "gameEnd.title": "ゲーム終了",
  "gameEnd.winTitle": "勝利",
  "gameEnd.subtitle": "マッチが終了しました。次のラウンドを始めるにはリスポーンするか、メニューに戻ってください。",
  "pause.title": "ゲームメニュー",
  "pause.resume": "続ける",
  "pause.menu": "メインメニューに戻る",
  "upgrade.title": "アップグレードを選択",
  "upgrade.generic.title": "アップグレード",
  "upgrade.generic.description": "ビルドを強化します。",
  "upgrade.newWeaponPrefix": "新しい武器:",
  "upgrade.stat.maxHp.title": "最大 HP",
  "upgrade.stat.maxHp.description": "最大 HP を増やします。",
  "upgrade.stat.speed.title": "移動速度",
  "upgrade.stat.speed.description": "移動速度を上げます。",
  "upgrade.stat.generic.title": "ステータス強化",
  "upgrade.stat.generic.description": "ステータスを強化します。",
  "upgrade.weapon.projectileShot.title": "プロジェクタイルショット",
  "upgrade.weapon.projectileShot.description": "ビルドにプロジェクタイルショットを追加します。",
  "upgrade.weapon.orbitingBalls.title": "軌道ボール",
  "upgrade.weapon.orbitingBalls.description": "ビルドに軌道ボールを追加します。",
  "upgrade.weapon.damageZone.title": "ダメージゾーン",
  "upgrade.weapon.damageZone.description": "キャラクターの周囲にダメージゾーンを追加します。",
  "upgrade.weapon.generic.title": "武器",
  "upgrade.weapon.generic.description": "この武器をビルドに追加します。",
  "upgrade.weaponUpgrade.frequency.title": "é »åº¦",
  "upgrade.weaponUpgrade.frequency.description": "より頻繁に攻撃します。",
  "upgrade.weaponUpgrade.range.title": "範囲",
  "upgrade.weaponUpgrade.range.description": "武器の射程を伸ばします。",
  "upgrade.weaponUpgrade.projectileCount.title": "弾数",
  "upgrade.weaponUpgrade.projectileCount.description": "より多くの弾を生成します。",
  "upgrade.weaponUpgrade.projectileSpeed.title": "弾速",
  "upgrade.weaponUpgrade.projectileSpeed.description": "弾を速くします。",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "軌道速度",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "軌道ボールをより速く回転させます。",
  "upgrade.weaponUpgrade.damage.title": "ダメージ",
  "upgrade.weaponUpgrade.damage.description": "与えるダメージを増やします。",
  "upgrade.weaponUpgrade.generic.title": "武器アップグレード",
  "upgrade.weaponUpgrade.generic.description": "この武器を強化します。",
  "defeat.title": "敗北",
  "defeat.subtitle": "リスポーンするかメニューに戻る",
  "defeat.respawn": "リスポーン",
  "defeat.menu": "メインメニュー",
  "error.generic": "問題が発生しました。",
} as const;
